import React from 'react';
import { Container, Grid } from '@tq/ui-components';

import { UserTable } from 'components';
import { UsersFilters, useManageUsersColumns } from './';
import { useManageConsultees } from '../../../../api';

import {
  manageConsulteePageNumberState,
  manageConsulteePageSizeState,
  manageConsulteesUserTableEditingRowState,
} from 'store';

export const ManageUsers: React.FC = () => {
  const { data } = useManageConsultees();

  const columns = useManageUsersColumns();

  return (
    <Container px={{ base: 0, lg: 4, xl: 0 }}>
      <Grid gridGap={2} mb='3rem'>
        <UsersFilters
          consultees={data?.consultees?.items ?? []}
          totalCount={data?.paginationInfo?.totalCount ?? 0}
        />
        <UserTable
          columns={columns}
          users={data?.consultees?.items ?? []}
          paginationInfo={data?.paginationInfo}
          pageNumberState={manageConsulteePageNumberState}
          pageSizeState={manageConsulteePageSizeState}
          editingState={manageConsulteesUserTableEditingRowState}
        />
      </Grid>
    </Container>
  );
};
